import PointForm from './PointForm';

export default PointForm;